var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import ja from 'date-fns/locale/ja';
import { useCallback, useMemo } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import InputError from '@/container/Ui/Common/InputError';
import { propBool, propFunc, propShape, propStr, } from '../../../helpers/custom-prop-types';
registerLocale('ja', ja);
/**
 * 日付入力
 * @deprecated TS 化したものを使用する (src/components/ui/Form/DatePickerField/DatePickerField.tsx)
 */
const PlainDatePicker = (props) => {
    const { className, dateFormat, input, meta, showError, wrapOnChange } = props, others = __rest(props, ["className", "dateFormat", "input", "meta", "showError", "wrapOnChange"]);
    const onChange = useCallback((e) => {
        if (wrapOnChange) {
            wrapOnChange(e);
        }
        input.onChange(e);
    }, [input, wrapOnChange]);
    const onBlur = useCallback(() => {
        input.onBlur();
    }, [input]);
    const warnClass = useMemo(() => (meta.touched && meta.error ? 'is-warning' : ''), [meta.touched, meta.error]);
    return (_jsxs(_Fragment, { children: [_jsx(DatePicker, Object.assign({}, input, { autoComplete: 'off', className: clsx(className, warnClass), dateFormat: dateFormat, locale: 'ja', onBlur: onBlur, onChange: onChange, selected: input.value }, others)), showError && _jsx(InputError, { meta: meta })] }));
};
PlainDatePicker.propTypes = {
    className: propStr().isRequired,
    dateFormat: propStr(),
    input: propShape().isRequired,
    meta: propShape().isRequired,
    showError: propBool(),
    wrapOnChange: propFunc(),
};
PlainDatePicker.defaultProps = {
    dateFormat: 'yyyy年MM月dd日',
    showError: false,
    wrapOnChange: undefined,
};
export default PlainDatePicker;
